export const GCLID = 'gclid';
export const MSCLKID = 'msclkid';
export const REFERRAL_CODE = 'referralCode';
export const UTM_QUERY_PARAMS = 'utmQueryParams';
export const SESSION_START_PAGE = 'onLoadUrl';
export const SESSION_REFERRER_PAGE = 'sessionReferrerUrl';
export const SESSION_PREVIOUS_PAGES = 'sessionPreviousPages';
